module.exports = __webpack_public_path__ + "static/media/gryphon_musee_northvanarts.cc0a4951.jpg";